import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

interface Route {
  name: string;
  path: string;
  layout?: string;
  collapse?: boolean;
  items?: Route[];
}

export const usePageTitle = (routes: Route[]) => {
  const location = useLocation();
  const [pageTitle, setPageTitle] = useState('');

  useEffect(() => {
    const findRouteTitle = (routes: Route[], pathname: string): string => {
      for (const route of routes) {
        if (route.collapse && route.items) {
          const nestedTitle = findRouteTitle(route.items, pathname);
          if (nestedTitle) return nestedTitle;
        } else {
          const fullPath = (route.layout || '') + route.path;
          if (pathname === fullPath) {
            return route.name;
          }
        }
      }
      return '';
    };

    const title = findRouteTitle(routes, location.pathname);
    setPageTitle(title);
  }, [location.pathname, routes]);

  return pageTitle;
};